<template>
  <div class="fs-adjustments fs-gamma">
    <div class="fs-back">
      <router-link :to="'/adjustments'" class="mi">arrow_back</router-link>
    </div>
    <div class="range-box">
      <fs-range-filter-wrapper min="0" max="2" defaultValue="1" :value="inputValue[0]" @input="onChange($event, 0)" label="Red" data-e2e="red"/>
      <fs-range-filter-wrapper min="0" max="2" defaultValue="1" :value="inputValue[1]" @input="onChange($event, 1)" label="Green" data-e2e="green"/>
      <fs-range-filter-wrapper min="0" max="2" defaultValue="1" :value="inputValue[2]" @input="onChange($event, 2)" label="Blue" data-e2e="blue"/>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Adjustments } from '@filestack/canvas-sdk';
import { Component } from 'vue-property-decorator';
import { FilterMixin } from './FilterMixin';

@Component
class Gamma extends FilterMixin {

  protected filter = new Adjustments.Gamma();

  protected value: any = { gamma: [1, 1, 1] };

  get inputValue() {
    return this.value.gamma;
  }

  private onChange(newVal: any, idx: number) {
    Vue.set(this.value.gamma, idx, newVal);
  }
}

export default Gamma;
</script>
